import { gql } from '@apollo/client'

export const InspectionAvailabilityWindowDataFragment = gql`
  fragment InspectionAvailabilityWindowDataFragment on InspectionAvailabilityWindow {
    id
    dayOfWeek
    startTime
    endTime
    createdAt
  }
`
